module.exports = __webpack_public_path__ + "img/anonim.338ae1bd.svg";